module.exports = __webpack_public_path__ + "static/media/mission-clear.b128d5a3.png";